import { render, staticRenderFns } from "./SupportContent.vue?vue&type=template&id=41d4d3b3&scoped=true&"
import script from "./SupportContent.vue?vue&type=script&lang=js&"
export * from "./SupportContent.vue?vue&type=script&lang=js&"
import style0 from "./SupportContent.vue?vue&type=style&index=0&id=41d4d3b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4d3b3",
  null
  
)

export default component.exports